<template>
  <div>
    <Banner :imgUrl="imgUrl" :bannerText="'随机资料'"></Banner>
    <div class="select">
      <h2>请选择梯种：</h2>
      <div class="select_box">
        <select id="disabledSelect" class="form-control" @change="handleChange" v-model="branchId">
          <option value="MAXIEZ-B、CZ扩张系列电梯">MAXIEZ-B、CZ扩张系列电梯</option>
          <option value="MAXIEZ-CZ系列电梯">MAXIEZ-CZ系列电梯</option>
          <option value="MAXIEZ-H、H-FE系列电梯">MAXIEZ-H、H-FE系列电梯</option>
          <option value="MAXIEZ-LZ(V)系列家用电梯">MAXIEZ-LZ(V)系列家用电梯</option>
          <option value="MAXIEZ-LZ(ZQX3)系列电梯">MAXIEZ-LZ(ZQX3)系列电梯</option>
          <option value="MAXIEZ-LZ(ZQX4、ZQX5)系列电梯">MAXIEZ-LZ(ZQX4、ZQX5)系列电梯</option>
          <option value="MAXIEZ-M系列电梯">MAXIEZ-M系列电梯</option>
        </select>
      </div>
    </div>
    <div class="title">
      <div class="title-bold text-center">{{ installList.name }}</div>
    </div>
    <div class="box">
      <DivisionLine></DivisionLine>
      <div class="box-content">
        <div class="item" v-for="(item, index) in installList.child" :key="index" @click="downloadFile(item)">
          <img v-if="item.flag == 'pdf'" src="@/assets/img/service/download/pdf.png" alt="" />
          <img v-if="item.flag == 'xlsx'" src="@/assets/img/service/download/excel.png" alt="" />
          <img v-if="item.flag == 'mp4'" src="@/assets/img/service/download/excel.png" alt="" />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <div class="title">
      <div class="title-bold text-center">{{ useList.name }}</div>
    </div>
    <div class="box" v-if="useList.child">
      <DivisionLine></DivisionLine>
      <div class="box-content">
        <div class="item" v-for="(item, index) in useList.child" :key="index" @click="downloadFile(item)">
          <img v-if="item.flag == 'pdf'" src="@/assets/img/service/download/pdf.png" alt="" />
          <img v-if="item.flag == 'xlsx'" src="@/assets/img/service/download/excel.png" alt="" />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "@/components/banner.vue";
import axios from "axios"
export default {
  name: "MAXIEZ_BCZ",
  components: {
    Banner,
  },
  data() {
    return {
      imgUrl: window.SITE_CONFIG.resourcesUrl + '/newsInformation/highSpeedBanner.png',
      installList: [],
      useList: [],
      textList: [],
      branchId: 'MAXIEZ-B、CZ扩张系列电梯',
      loading: null
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.http({
        url: this.http.adornUrl('/pc/file/getManualsFileList?name=' + this.branchId),
        method: 'get',
      }).then(({ data }) => {
        data[0].child.map((item) => {
          item.flag = item.name.split('.')[1]
        })
        this.installList = data[0]
        data[1].child.map((item) => {
          item.flag = item.name.split('.')[1]
        })
        this.useList = data[1]
      })
    },
    handleChange() {
      this.init()
    },
    // pdf下载
    downloadFile(item) {
      const ua = navigator.userAgent.toLowerCase();
      const isWeixin = ua.indexOf("micromessenger") != -1;
      if (isWeixin) {
        this.$alert('请用浏览器打开页面进行下载。', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            return
          }
        });
      } else {
        this.$confirm('确认下载文件么?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: "MessageBox",
        }).then(() => {
          this.loading = this.$loading({
            lock: true,
            text: '正在加载,请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.http({
            url: this.http.adornUrl('/pc/file/getFileByName?fileName=' + item.name + '&filePath=' + item.path),
            method: 'get',
            responseType: 'arraybuffer',
          }).then(res => {
            this.download(res, item.name, item.flag)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下载'
          });
        });
      }
    },
    download(res, filename, fileFlag) {
      const isPath = navigator.userAgent.match(
        // match方法可在字符串内检索指定的值，
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
        ? "Moblie"
        : "Pc";
      if (fileFlag == 'pdf' && isPath == 'Pc') {
        const blob = new Blob([res.data], { 'type': 'application/pdf' });
        const URL = window.URL || window.webkitURL;
        // 根据解析后的blob对象创建URL 对象
        const herf = URL.createObjectURL(blob);
        window.open(herf)
      } else {
        // 创建blob对象，解析流数据
        const blob = new Blob([res.data], { 'type': 'application/octet-stream' });
        // 兼容webkix浏览器，处理webkit浏览器中href自动添加blob前缀，默认在浏览器打开而不是下载
        const URL = window.URL || window.webkitURL;
        // 根据解析后的blob对象创建URL 对象
        const herf = URL.createObjectURL(blob);

        const a = document.createElement("a");
        // 下载链接
        a.href = herf;
        a.target = "_blank"
        // 下载文件名,如果后端没有返回，可以自己写a.download = '文件.pdf'
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // 在内存中移除URL 对象
        window.URL.revokeObjectURL(herf);
      }
      this.loading.close();
    }
  }
}
</script>
<style scoped lang="less">
.select {
  max-width: 1440px;
  width: 100%;
  margin: 40px auto;
  box-sizing: border-box;

  h2 {
    font-size: 24px;
    margin-bottom: 30px;
    font-weight: bold;
  }

  .select_box {
    width: 30%;
  }


}

@media (max-width: 991px) {
  .select {
    padding: 20px;
    margin: 0 auto;

    h2 {
      font-size: 24px;
      margin-bottom: 20px;
    }

    .select_box {
      width: 90%;
    }


  }
}

.title {
  margin: 20px 0;
}

.title .title-bold {
  font-size: 30px;
  padding-right: 5px;
  font-weight: bold;
}

.box {
  max-width: 1440px;
  width: 100%;
  margin: auto;



  .box-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;

    .content-title {
      width: 100%;
      padding: 10px 0;
      font-size: 20px;
      font-weight: bold;
    }

    .item {
      width: 20%;
      cursor: pointer;
      margin: 15px 0;

      img {
        width: 60%;
        margin: auto;
      }

      p {
        font-size: 16px;
        box-sizing: border-box;
        padding: 0 12px;
      }
    }

    .item-small {
      width: 15%;
    }
  }
}

@media (max-width: 991px) {
  .title .title-bold {
    font-size: 24px;
  }

  .box {
    padding: 20px;

    .box-content {
      justify-content: space-between;

      .item {
        width: 50%;
        cursor: pointer;
        margin: 15px 0;

        img {
          width: 60%;
          margin: auto;
        }

        p {
          font-size: 12px;
        }
      }

    }
  }

}
</style>


// WEBPACK FOOTER //
// src/view/contactUs/information.vue